/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../../loading/loading.component';
import {
  STUDY_PROTOCOL_NO,
  THERAPEUTIC_AREA,
  STUDY_PHASE,
  PROTOCOL_NAME,
  SHOW_LESS,
  SHOW_MORE,
  SWITCH_TO_UAT,
  DATA_ARCHIVING,
  DATA_EXPORTED
} from '../../../const';
import Notification from '../../common/notification/notification.component';
import { Row, Grid, Col } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import ReportsContainer from '../reports/reports.container';
import StudyIcon from '../../../assets/images/icons/Study-icon.svg';
import CloudDownloadIcon from '../../../assets/images/icons/cloud_download.svg';
import CloudQueueIcon from '../../../assets/images/icons/cloud_queue.svg';
import StudyInformationService from './study.information.service';
import { EXIT_TEST_COPY, SELECTED_SPONSOR } from '../../../constants/common';

import { path } from 'ramda';

class StudyInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  MAX_CHAR = 67;

  componentDidMount() {
    this.props.loadData(this.props.studyGid);
    this.props.getSignedConsentingsNumber(this.props.studyGid);
  }

  flip = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  descriptionData = (string) => {
    let description = string;
    if (string.length > this.MAX_CHAR) {
      let buttonLabel;
      if (!this.state.expanded) {
        string = string.substring(0, this.MAX_CHAR) + '...';
        buttonLabel = SHOW_MORE;
      } else {
        buttonLabel = SHOW_LESS;
      }
      description = (
        <div>
          {string}{' '}
          <button id="description-button" className="description-button link" onClick={this.flip}>
            {buttonLabel}
          </button>
        </div>
      );
    }
    return description;
  };

  switchToUAT = (uatTenantId, allocations, navigateToTenantFunction) => {
    StudyInformationService.navigateToUAT(uatTenantId, allocations, navigateToTenantFunction);
    this.props.history.replace('');
  };

  render() {
    const { error, isFetching, study, user, sponsor, hasNewDataAvailable, signedConsentingsNo } = this.props;
    const uatTenantId = study && study.uatTenantId;
    const allocations = user && user.allocations;
    const uatTenant =
      uatTenantId && allocations && StudyInformationService.getTenantFromAllocations(uatTenantId, allocations);
    const isInUAT = sponsor && sponsor.selectedSponsor && sponsor.selectedSponsor.type === 'UAT';
    let switchTenantbutton;
    if (isInUAT) {
      const tenantDatabaseName = sponsor && path(['selectedSponsor', 'sponsorname'], sponsor);
      let tenant =
        tenantDatabaseName && StudyInformationService.getProductionTenantForUAT(tenantDatabaseName, allocations);
      switchTenantbutton = (
        <Button
          theme="active large-button switch-button"
          id="exit-test-copy-button"
          disabled={!tenant}
          label={EXIT_TEST_COPY}
          handleClick={() => {
            this.props.navigateToTenant(tenant);
            sessionStorage.setItem(SELECTED_SPONSOR, JSON.stringify(tenant));
            this.props.history.replace('');
          }}
        />
      );
    } else {
      switchTenantbutton = (
        <Button
          theme="active large-button switch-button"
          id="switch-to-uat"
          disabled={!uatTenantId || !uatTenant}
          handleClick={() => this.switchToUAT(uatTenantId, allocations, this.props.navigateToTenant)}
          label={SWITCH_TO_UAT}
        />
      );
    }

    let content;

    if (isFetching || null == study) {
      content = <Loading />;
    } else if (error) {
      content = <Notification type="error" data={this.props.error} />;
    } else {
      content = (
        <div>
          <div className="study-information-section">
            <Grid fluid id="study-information-grid">
              <Row>
                <Col className="study-icon-column" xs={1}>
                  <img src={StudyIcon} />
                </Col>
                <Col className="details-col study-name page-title" xs={8}>
                  <Row>{study ? study.name : ''}</Row>
                  {hasNewDataAvailable !== null && signedConsentingsNo > 0 && (
                    <Row className="exported-status">
                      <img src={hasNewDataAvailable ? CloudDownloadIcon : CloudQueueIcon} />
                      {hasNewDataAvailable ? DATA_ARCHIVING : DATA_EXPORTED}
                    </Row>
                  )}
                </Col>
                <Col>
                  <div className="action-container">
                    <ReportsContainer signedConsentingsNo={signedConsentingsNo} />
                    {switchTenantbutton}
                  </div>
                </Col>
              </Row>
              <br />
              <br />
              <Row className="study-information-header">
                <Col className="study-information-col" xs={2}>
                  {THERAPEUTIC_AREA}
                </Col>
                <Col className="study-information-col" xs={2}>
                  {STUDY_PHASE}
                </Col>
                <Col className="study-information-col" xs={2}>
                  {STUDY_PROTOCOL_NO}
                </Col>
                <Col className="study-information-col" xs={6}>
                  {PROTOCOL_NAME}
                </Col>
              </Row>
              <Row className="study-information-content">
                <Col className="study-information-col" xs={2}>
                  {study.area}
                </Col>
                <Col className="study-information-col" xs={2}>
                  {study.phase}
                </Col>
                <Col className="study-information-col" xs={2}>
                  {study.protocolNumber}
                </Col>
                <Col className="study-information-col" xs={6}>
                  {this.descriptionData(study.description)}
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
      );
    }
    return <div className="study-information">{content}</div>;
  }
}

StudyInformation.propTypes = {
  studyGid: PropTypes.string.isRequired,
  error: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  study: PropTypes.object,
  loadData: PropTypes.func,
  hasNewDataAvailable: PropTypes.bool,
  getSignedConsentingsNumber: PropTypes.func,
  signedConsentingsNo: PropTypes.number
};

export default StudyInformation;
